import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import gegVfs from "./gegFonts";

// Register default Roboto fonts
for (const [fileName, fileContent] of Object.entries(pdfFonts)) {
  pdfMake.virtualfs.writeFileSync(fileName, fileContent);
}
// Register GEG fonts
for (const [fileName, fileContent] of Object.entries(gegVfs)) {
  const binary = atob(fileContent);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  pdfMake.virtualfs.writeFileSync(fileName, bytes.buffer);
}
pdfMake.fonts = {
  GEG: {
    normal: "GEG-BodyCopy.ttf",
    bold: "GEG-Bold.ttf",
    italics: "GEG-BodyCopyItalic.ttf",
    bolditalics: "GEG-BodyCopyHighlightItalic.ttf",
  },
};

const DARK_BLUE = "#145CA1";
const WHITE = "#FFFFFF";
const SOLD_TO_BG = "#B5D6FA";
const SHIP_TO_BG = "#A6D699";

const GODREJ_LOGO_SVG = `<svg width="60" height="28" viewBox="0 0 60 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M56.1651 4.79229C56.1288 5.14467 56.3517 5.38306 56.6574 5.50743C57.0357 5.66289 57.5436 5.64735 57.8286 5.45561C58.1913 5.21723 58.6163 4.50208 58.7199 4.08751C58.808 3.72994 58.7303 3.35682 58.4867 3.14953C57.9478 2.68314 57.2586 3.20654 56.8751 3.59002C56.5279 3.93723 56.2118 4.2637 56.1599 4.79229M47.231 10.3372C48.0757 10.2958 48.5473 9.82419 49.0707 9.22305C49.4542 8.78775 49.8325 8.3369 49.5993 8.05706C49.3454 7.75131 48.3815 8.76702 48.2053 8.92767C47.7752 9.32151 47.402 9.75682 47.2259 10.3372H47.231ZM34.4777 6.5335C34.1046 5.63698 33.7366 4.8752 33.234 4.19115C32.8401 3.65739 32.3167 3.15472 31.6689 2.75051C31.0834 2.38775 29.7308 1.95763 29.1711 2.61577C28.6685 3.20654 28.9017 3.81285 29.3111 4.29998C29.6686 4.73528 30.1506 5.12395 30.5392 5.37269C31.8089 6.18111 33.0526 6.42467 34.4829 6.5335H34.4777ZM33.2806 7.8705C33.3946 8.11407 33.5345 8.44054 33.6537 8.68411C33.4412 9.12459 32.9697 9.4407 32.6225 9.80346C32.2856 10.1558 31.871 10.5445 31.4357 11.1456C31.187 11.4877 30.9279 11.8401 30.8191 12.3324C30.7413 12.6951 30.7983 13.0268 31.016 13.146C31.3528 13.3325 31.7985 13.2185 32.0939 12.9905C32.6691 12.5552 33.0837 11.9903 33.4568 11.4099C33.7677 10.928 33.9439 10.3476 34.1823 9.762C34.3792 9.28006 34.4621 8.8033 34.4 8.37836C34.3689 8.16071 34.1668 8.02597 33.918 7.93787C33.7107 7.94305 33.4879 7.86532 33.2806 7.8705ZM8.05892 20.5928C7.805 21.3131 7.3386 22.1474 6.73228 22.8626C6.36953 23.2875 5.56111 24.526 4.73714 25.1894C4.30702 25.5366 3.87172 25.7283 3.4986 25.5625C2.91302 25.3034 3.73698 24.1685 3.92354 23.9197C4.6335 22.9921 5.56629 22.2614 6.46281 21.5359C7.06913 21.0488 7.4267 20.8415 8.05892 20.5928ZM27.9481 11.4099L27.3936 11.3685L26.8702 11.5188L26.3831 12.0059L25.6732 12.9024L24.8129 13.9855L23.8387 14.8094C23.45 15.0737 23.0665 15.3328 22.6779 15.5971C22.1804 15.82 21.6932 16.0791 21.1802 16.2708C20.6568 16.4677 20.1023 16.4937 19.5737 16.4211C19.0762 16.3537 18.7239 16.0998 18.501 15.6749C18.3507 15.3795 18.3196 15.0064 18.3352 14.6281C18.3507 14.286 18.4181 13.9492 18.4596 13.6435C18.159 13.83 17.8066 14.0321 17.5112 14.2187C17.0241 14.5452 16.537 14.8664 16.0498 15.1929C15.5835 15.4883 15.1378 15.7992 14.7388 16.1672C14.4123 16.7165 14.091 17.2658 13.7645 17.8151C13.5158 18.1779 13.267 18.5406 13.0183 18.8982C12.7177 19.3076 12.4171 19.7222 12.1218 20.1315L11.2252 21.2924C9.95042 23.018 8.26621 24.5105 6.58718 25.7853C5.43674 26.6611 4.04791 27.454 2.63836 27.8167C1.41018 28.1328 -0.289572 28.0862 0.0420874 26.345C0.218282 25.4122 0.840144 24.4638 1.46201 23.7643C3.23431 21.7587 5.58184 20.2922 7.82573 18.8619C8.9088 18.1416 9.98669 17.4316 11.0801 16.7269C11.2822 16.561 11.4066 16.333 11.5569 16.1309C11.7797 15.8148 12.044 15.5609 12.0544 15.2344C12.0544 15.1307 11.9352 15.1877 11.8678 15.2344C11.4999 15.4935 11.0853 15.6697 10.6707 15.8303C10.08 16.0635 9.49439 16.1931 8.91398 16.3175C8.1522 16.4781 7.42151 16.5092 6.70637 16.3537C5.90314 16.1827 5.3901 15.6541 5.20872 14.8198C5.07399 14.2135 5.10508 13.5864 5.28127 12.9853C5.49893 12.2546 5.86168 11.5758 6.28144 10.9643C6.83075 10.1662 7.41633 9.36297 8.10556 8.68411C8.83107 7.96896 9.58249 7.26937 10.3754 6.5905C11.2356 5.85463 12.1373 5.17059 13.0701 4.53318C13.9355 3.94241 14.8372 3.40864 15.7648 2.9267C16.8013 2.38775 17.8688 1.91618 18.9467 1.46533C20.3977 0.864192 21.7969 0.428889 23.1754 0.117958C23.7506 -0.0115964 24.3051 -0.0323252 24.7818 0.0454076C25.0928 0.0972294 25.2068 0.247513 25.3052 0.345974C25.0565 0.745002 24.8077 1.14403 24.559 1.54306C24.2481 2.03018 23.9371 2.51731 23.6262 3.00443C23.0406 2.99407 22.455 2.97852 21.8694 2.96816C21.3098 2.95779 20.5946 3.01998 19.7344 3.22727C18.7446 3.47083 17.8222 3.80249 17.0396 4.27407C16.0861 4.84929 15.3036 5.3986 14.7595 5.88573C14.1946 6.38322 13.6194 6.85998 13.0753 7.38338C12.6192 7.82386 12.2202 8.32135 11.8419 8.8033C11.4377 9.32151 10.992 9.80864 10.6448 10.3735C10.3339 10.8762 10.0748 11.4099 9.85714 11.9074C9.67058 12.3375 9.49957 12.7728 9.40629 13.2185C9.28192 13.8093 9.56694 14.1876 10.1525 14.229C10.6811 14.2653 11.1475 14.1254 11.5724 13.9285C12.0129 13.7264 12.4171 13.3999 12.9094 13.0371C13.8111 12.3635 14.8009 11.5032 15.3917 10.8762C15.6975 10.5497 16.1172 10.1766 16.5525 9.705C16.8894 9.34224 17.1899 8.9484 17.5268 8.58046C17.8688 8.20734 18.2626 7.8705 18.615 7.50775C18.9415 7.23309 19.2265 6.98953 19.5478 6.78224C19.9106 6.54386 20.2681 6.39358 20.6309 6.37285C21.0092 6.35212 21.2165 6.45058 21.3046 6.59569C21.4393 6.8237 21.4134 7.0569 21.1906 7.34192C20.8382 7.79795 20.491 8.26435 20.1438 8.72556C19.781 9.21269 19.4286 9.705 19.0607 10.1869C18.7705 10.5652 18.4492 10.9228 18.1642 11.3115C17.9258 11.6379 17.7133 11.9852 17.4905 12.322C17.7289 12.3583 18.0035 12.2702 18.3145 12.0629C18.7653 11.7571 19.211 11.4721 19.6515 11.2493C20.4029 10.2128 21.3979 9.17123 22.4084 8.35763C23.6728 7.34192 26.4194 5.27941 27.8393 6.92735C28.0518 7.17609 28.1347 7.42484 28.1243 7.67358C28.0932 8.35763 27.9119 9.02613 27.7927 9.69463C27.7253 9.88119 28.1192 9.80864 28.3627 9.80346C28.6374 9.85528 29.6583 8.88621 29.7049 8.83439C30.2231 8.27471 30.8709 7.59585 31.3425 7.145C31.0989 7.02062 30.8294 6.89107 30.5911 6.77706C30.0366 6.50759 29.4199 6.34694 28.8965 6.02046C28.2642 5.62662 27.6942 5.18095 27.2589 4.62646C26.9583 4.24816 26.7251 3.81804 26.5697 3.31536C26.3054 2.45512 26.5386 1.74516 27.0464 1.2684C27.4973 0.848646 28.1658 0.599901 28.8965 0.584355C29.622 0.563626 30.3475 0.802006 31.0212 1.0663C32.0576 1.47569 32.9075 2.05609 33.6226 2.78678C34.2186 3.3931 34.7212 4.09787 35.1669 4.88038C35.4675 5.40897 35.711 5.99974 35.9753 6.55423C37.2812 6.54905 38.4265 6.45577 39.7065 6.51277C40.1159 6.5335 40.603 6.78224 40.9451 7.23309C41.1161 7.56994 41.2301 7.90678 41.2819 8.24362C41.2974 8.30062 41.37 8.3369 41.5047 8.26435C41.6913 7.98451 41.8727 7.69431 42.1577 7.38856C42.5723 6.93771 42.9816 6.63714 43.3289 6.48686C43.6346 6.35212 43.9611 6.32103 44.2046 6.44022C44.4067 6.53868 44.5622 6.78743 44.4741 7.02581C44.3394 7.39374 44.0751 7.68394 43.9818 8.0156C43.8626 8.41981 43.7901 8.82921 43.759 9.22823C43.7279 9.5858 43.6916 9.95374 43.873 10.2388C44.0025 10.446 44.1476 10.5186 44.4638 10.5704C44.9301 10.1248 45.2981 9.68427 45.7386 9.24896C46.2982 8.68929 46.9201 8.15034 47.6197 7.67358C48.1794 7.2901 48.7701 6.9999 49.335 6.68896C49.8791 6.3884 50.9 5.96346 51.4752 6.45577C51.7033 6.65269 51.7603 7.08281 51.5012 7.69949C51.0969 8.66856 50.3041 9.54953 49.3713 10.2802C48.3763 11.0575 47.2207 11.6639 46.1894 12.0214C46.1272 12.1147 46.065 12.208 46.0029 12.3013C45.8837 12.6277 45.8681 12.892 45.9303 13.0993C46.0443 13.4724 46.2101 13.6279 46.4485 13.6849C46.832 13.7782 47.2414 13.7212 47.5523 13.5916C48.5059 13.1874 49.4179 12.3997 50.1849 11.7105C50.8223 11.1405 51.4079 10.4564 52.009 9.84491C52.3977 9.44589 52.8019 8.88621 53.175 8.47164C53.5067 8.1037 53.8331 7.74613 54.2063 7.41447C54.4913 7.15536 54.797 6.91698 55.1235 6.70969C55.3567 6.55941 55.6054 6.41431 55.8749 6.33139C56.1703 6.23812 56.4968 6.22257 56.7455 6.35731C57.0098 6.49722 57.1394 6.89107 56.8854 7.34192C56.6574 7.75131 56.2895 8.06224 55.9941 8.425C55.5847 8.94321 55.1701 9.45107 54.7711 9.97447C54.4446 10.4046 54.1233 10.8347 53.8331 11.2907C53.403 11.9592 52.9988 12.6433 52.6101 13.3325C52.237 13.9958 51.9054 14.6799 51.553 15.3536C51.211 16.0117 50.8741 16.675 50.5165 17.328C50.102 18.0949 49.677 18.8515 49.2469 19.6081C48.8945 20.2248 48.5473 20.8415 48.169 21.4426C47.7026 22.1785 47.2103 22.8936 46.7128 23.6036C46.3138 24.1685 45.9044 24.7333 45.4691 25.2723C45.1063 25.7283 44.728 26.174 44.3186 26.5885C43.9974 26.9202 43.6761 27.2622 43.2874 27.5058C42.9091 27.739 42.4893 27.9774 42.0437 27.9981C41.6861 28.0188 41.2923 27.8685 41.0331 27.6198C40.8155 27.4177 40.7378 27.0705 40.7533 26.7751C40.7689 26.4279 40.9191 26.0807 41.1057 25.7905C41.4322 25.2723 41.8882 24.8473 42.2821 24.3809C42.7277 23.8524 43.1838 23.3393 43.6242 22.8056C44.0284 22.3132 44.4067 21.8002 44.8006 21.3027C45.3136 20.6446 45.8474 19.9968 46.3501 19.3283C46.7128 18.8515 47.0497 18.3541 47.4072 17.8721C47.8995 17.2036 48.4074 16.5507 48.8893 15.8718C49.2469 15.3691 49.5786 14.8561 49.9258 14.343C50.1227 13.9751 50.3144 13.6072 50.5269 13.2392C50.6046 13.006 50.6513 12.6537 50.3714 13.006C50.2367 13.1771 50.0605 13.3014 49.8999 13.4517C49.2314 13.9803 48.568 14.4933 47.8788 14.9701C47.3088 15.3639 46.718 15.7319 46.091 16.0584C45.2307 16.504 44.2772 16.8409 43.4118 16.2449C42.8262 15.8407 42.6552 15.1307 42.7122 14.4001C42.764 13.6642 43.0438 12.9076 43.3289 12.3945C42.8365 12.6951 42.2872 12.8195 41.6965 12.664C41.2508 12.55 40.9917 12.1147 40.7948 11.6069C40.7274 11.5343 40.6289 11.5447 40.5046 11.6535C39.5044 13.2082 38.4731 15.1567 37.3123 16.5351H34.3689C35.1566 15.224 36.0116 13.8196 36.7993 12.5086C37.2502 11.7157 37.6803 10.9435 38.1259 10.1455C38.3073 9.819 38.4161 9.48734 38.4628 9.15568C38.5302 8.66856 38.4369 8.37836 38.214 8.21253C38.0016 8.05188 37.6647 7.92232 37.359 7.89641C36.9859 7.86532 36.6542 7.9016 36.2707 7.91196C36.2552 8.38872 36.1774 8.87066 36.0686 9.35779C35.9391 9.92783 35.7629 10.4357 35.54 10.8969C35.2187 11.5654 34.9441 12.2754 34.5295 12.9179C34.1564 13.4984 33.7211 14.0166 33.2754 14.4778C32.7831 14.9908 32.2131 15.395 31.6275 15.7526C31.1715 16.0324 30.6481 16.2345 30.0677 16.39C29.4665 16.4937 28.9224 16.447 28.4404 16.2605C28.0155 16.0946 27.6113 15.7111 27.3833 15.2033C27.2019 14.7991 27.1915 14.3379 27.1864 13.9077C27.176 13.3999 27.3315 12.892 27.5387 12.3894C27.6735 12.0629 27.8341 11.7468 27.9896 11.4151L27.9481 11.4099ZM24.9062 11.4721C24.787 11.2959 24.7093 11.0938 24.6834 10.8554C24.6471 10.4875 24.8958 10.2025 25.2793 9.95374C25.5799 9.74645 25.9478 9.60135 26.2847 9.37852C26.4246 9.29042 26.4971 9.06241 26.3676 8.8033C26.3002 8.66856 26.124 8.6271 25.9167 8.74111C24.8544 9.3267 23.6884 10.5082 23.0095 11.5032C22.6882 11.9748 22.4032 12.4153 22.1907 12.835C22.0094 13.1978 21.9679 13.5035 22.17 13.7575C22.2944 13.9077 22.5431 13.9958 22.8022 13.8611C23.2634 13.6175 23.5796 13.2341 23.9423 12.8972C24.4191 12.4671 24.7611 11.9852 24.9114 11.4618L24.9062 11.4721Z" fill="#810055"/></svg>`;

const generateIsobPdf = (data = {}) => {
  const v = (key) => data[key] || "";

  const sectionHeader = (text, italicText) => ({
    table: {
      widths: ["*"],
      body: [[{ text: italicText ? [{ text, bold: true }, { text: italicText, bold: true, italics: true }] : text, bold: !italicText, fontSize: 10, color: "#333333", fillColor: "#D6DEE0", alignment: "center", margin: [0, 3, 0, 3] }]],
    },
    layout: "noBorders",
    margin: [0, 10, 0, 0],
  });


  const subHeader = (text) => ({
    table: {
      widths: ["*"],
      body: [[{ text, bold: true, fontSize: 8, color: DARK_BLUE, alignment: "center", margin: [0, 2, 0, 2] }]],
    },
    layout: { hLineWidth: () => 0.5, vLineWidth: () => 0.5, hLineColor: () => DARK_BLUE, vLineColor: () => DARK_BLUE },
    margin: [0, 0, 0, 0],
  });

  const toggleSvg = (isOn) => isOn
    ? '<svg width="30" height="14"><rect x="0" y="0" width="30" height="14" rx="7" fill="#4CAF50"/><circle cx="23" cy="7" r="5" fill="#fff"/></svg>'
    : '<svg width="30" height="14"><rect x="0" y="0" width="30" height="14" rx="7" fill="#ccc"/><circle cx="7" cy="7" r="5" fill="#fff"/></svg>';

  const toggleWithLabel = (isOn) => ({
    columns: [
      { svg: toggleSvg(isOn), fit: [24, 10], width: 26 },
      { text: isOn ? "Yes" : "No", margin: [2, 1, 0, 0] },
    ],
  });

  const kv = (label, value) => [
    { text: label, bold: true, fontSize: 8 },
    { text: value || "", fontSize: 8 },
  ];

  const docDefinition = {
    pageSize: "A4",
    pageMargins: [30, 30, 30, 30],
    defaultStyle: { fontSize: 7, font: "GEG" },
    content: [
      // Main Header
      {
        table: {
          widths: ["*", 48],
          body: [[
            { text: `ISOB Summary: ${v("enquiryNo")} | ${v("customerName")} | Rev No. ${v("revNo")}`, bold: true, fontSize: 11, color: WHITE, alignment: "center", margin: [0, 3, 0, 3], fillColor: DARK_BLUE },
            { svg: GODREJ_LOGO_SVG, fit: [46, 14], alignment: "center", margin: [0, 3, 0, 0], fillColor: WHITE },
          ]],
        },
        layout: { hLineWidth: () => 0, vLineWidth: () => 0 },
        margin: [0, 0, 0, 0],
      },

      // Section 1: ORDER SUMMARY
      {
        table: {
          widths: ["*"],
          body: [[{ text: [{ text: "Section 1: ORDER SUMMARY  ", bold: true }], fontSize: 10, color: "#333333", fillColor: "#D6DEE0", alignment: "center", margin: [0, 3, 0, 3] }]],
        },
        layout: "noBorders",
        margin: [0, 0, 0, 0],
      },
      {
        table: {
          widths: ["12%", "13%", "12%", "13%", "12%", "13%", "12%", "13%"],
          body: [
            [...kv("Enquiry No.", v("enquiryNo")), ...kv("Customer Name", v("customerName")), ...kv("Branch", v("Branch")), ...kv("PG", v("PG"))],
            [...kv("Order Value", v("OrderValueLakhs")), ...kv("Routing", v("Routing")), ...kv("Customer Type", v("CustomerType")), ...kv("Channel Type", v("ChannelType"))],
            [...kv("OrderType", v("OrderType")), ...kv("Commercial Approval", v("CommercialApproval")), ...kv("Installation Scope", v("ScopeOfInstallation")), ...kv("PO DATE", v("PODate"))],
            [...kv("LD DATE", v("LDDate")), ...kv("DAP date", v("DAPDate")), ...kv("Site Readiness", v("SiteReadiness")), { text: "", colSpan: 2 }, ""],
          ],
        },
        layout: "noBorders",
        margin: [0, 8, 0, 12],
      },

      // Sold To / Ship To
      {
        table: {
          widths: ["50%", "50%"],
          body: [
            [
              { text: "Sold To Details", bold: true, fontSize: 8, color: DARK_BLUE, alignment: "center", margin: [0, 2, 0, 2] },
              { text: "Ship To Details", bold: true, fontSize: 8, color: DARK_BLUE, alignment: "center", margin: [0, 2, 0, 2] },
            ],
          ],
        },
        layout: { hLineWidth: () => 0.5, vLineWidth: () => 0.5, hLineColor: () => DARK_BLUE, vLineColor: () => DARK_BLUE },
        margin: [0, 5, 0, 0],
      },
      {
        table: {
          widths: ["11%", "14%", "11%", "14%", "11%", "14%", "11%", "14%"],
          body: [
            [{ text: "BP Code", bold: true, fillColor: SOLD_TO_BG }, { text: v("BPCode"), fillColor: SOLD_TO_BG }, { text: "BP Name", bold: true, fillColor: SOLD_TO_BG }, { text: v("BPName"), fillColor: SOLD_TO_BG }, { text: "BP Code", bold: true, fillColor: SHIP_TO_BG }, { text: v("Ship_BPCode"), fillColor: SHIP_TO_BG }, { text: "BP Name", bold: true, fillColor: SHIP_TO_BG }, { text: v("Ship_BPName"), fillColor: SHIP_TO_BG }],
            [{ text: "BP GSTN", bold: true, fillColor: SOLD_TO_BG }, { text: v("BPGSTN"), fillColor: SOLD_TO_BG }, { text: "CIN", bold: true, fillColor: SOLD_TO_BG }, { text: v("CIN"), fillColor: SOLD_TO_BG }, { text: "BP GSTN", bold: true, fillColor: SHIP_TO_BG }, { text: v("Ship_BPGSTN"), fillColor: SHIP_TO_BG }, { text: "CIN", bold: true, fillColor: SHIP_TO_BG }, { text: v("Ship_CIN"), fillColor: SHIP_TO_BG }],
            [{ text: "BP TAN", bold: true, fillColor: SOLD_TO_BG }, { text: v("BPTAN"), fillColor: SOLD_TO_BG }, { text: "Location", bold: true, fillColor: SOLD_TO_BG }, { text: v("Location"), fillColor: SOLD_TO_BG }, { text: "BP TAN", bold: true, fillColor: SHIP_TO_BG }, { text: v("Ship_BPTAN"), fillColor: SHIP_TO_BG }, { text: "Location", bold: true, fillColor: SHIP_TO_BG }, { text: v("Ship_Location"), fillColor: SHIP_TO_BG }],
            [{ text: "BP Address", bold: true, fillColor: SOLD_TO_BG }, { text: v("BPAddress"), fillColor: SOLD_TO_BG }, { text: "Pincode", bold: true, fillColor: SOLD_TO_BG }, { text: v("Pincode"), fillColor: SOLD_TO_BG }, { text: "BP Address", bold: true, fillColor: SHIP_TO_BG }, { text: v("Ship_BPAddress"), fillColor: SHIP_TO_BG }, { text: "Pincode", bold: true, fillColor: SHIP_TO_BG }, { text: v("Ship_Pincode"), fillColor: SHIP_TO_BG }],
            [{ text: "Contact Name", bold: true, fillColor: SOLD_TO_BG }, { text: v("ContactName"), fillColor: SOLD_TO_BG }, { text: "Contact Mobile", bold: true, fillColor: SOLD_TO_BG }, { text: v("Mobile"), fillColor: SOLD_TO_BG }, { text: "Contact Name", bold: true, fillColor: SHIP_TO_BG }, { text: v("Ship_ContactName"), fillColor: SHIP_TO_BG }, { text: "Contact Mobile", bold: true, fillColor: SHIP_TO_BG }, { text: v("Ship_Mobile"), fillColor: SHIP_TO_BG }],
            [{ text: "Contact Email", bold: true, fillColor: SOLD_TO_BG }, { text: v("Email"), fillColor: SOLD_TO_BG }, { text: "Contact Designation", bold: true, fillColor: SOLD_TO_BG }, { text: v("Designation"), fillColor: SOLD_TO_BG }, { text: "Contact Email", bold: true, fillColor: SHIP_TO_BG }, { text: v("Ship_Email"), fillColor: SHIP_TO_BG }, { text: "Contact Designation", bold: true, fillColor: SHIP_TO_BG }, { text: v("Ship_Designation"), fillColor: SHIP_TO_BG }],
            [{ text: "Address Code", bold: true, fillColor: SOLD_TO_BG }, { text: v("AddressCode"), fillColor: SOLD_TO_BG }, { text: "", fillColor: SOLD_TO_BG }, { text: "", fillColor: SOLD_TO_BG }, { text: "Address Code", bold: true, fillColor: SHIP_TO_BG }, { text: v("Ship_AddressCode"), fillColor: SHIP_TO_BG }, { text: "", fillColor: SHIP_TO_BG }, { text: "", fillColor: SHIP_TO_BG }],
          ],
        },
        layout: {
          hLineWidth: () => 0,
          vLineWidth: (i) => (i === 4 ? 0.5 : 0),
          vLineColor: () => DARK_BLUE,
          paddingLeft: () => 4, paddingRight: () => 4, paddingTop: () => 3, paddingBottom: () => 3,
        },
        margin: [0, 0, 0, 0],
      },

      // Other Details
      subHeader("Other Details"),
      {
        table: {
          widths: ["25%", "25%", "25%", "25%"],
          body: [
            [{ text: "PO number", bold: true }, { text: "Segment", bold: true },{ text: "Salesperson Name", bold: true }, { text: "Salesperson Email", bold: true } ],
            [v("PO_number"), v("Segment"),v("SalespersonName"), v("SalespersonEmail")],
            [{ text: "Application", bold: true }, { text: "SKU stored", bold: true }, { text: "BOM type", bold: true }, { text: "Document Exchange Place", bold: true }],
            [v("WHType"), v("SKU_stored"), v("BOM_type"), v("DocumentExchangePlace")],
            [{ text: "Related to Past Supply", bold: true }, { text: "Past SO Number", bold: true }, { text: "Design Enq. No.", bold: true }, { text: "Drawing Revision Number", bold: true }],
            [v("RelatedToPastSupply"), v("PastSONo"), v("DesignEnqNo"), v("DrawingRevisionNumber")],
          ],
        },
        layout: "noBorders",
        margin: [0, 5, 0, 10],
      },

      // Section 2: PRODUCT GROUPS & COMPONENTS
      sectionHeader("Section 2: PRODUCT GROUPS & COMPONENTS"),
      {
        table: {
          widths: ["16%", "28%", "14%", "18%", "18%", "6%"],
          headerRows: 1,
          body: [
            [
              { text: "PG", bold: true, color: DARK_BLUE, fillColor: SOLD_TO_BG },
              { text: "PG Component", bold: true, color: DARK_BLUE, fillColor: SOLD_TO_BG },
              { text: "APO/Standard", bold: true, color: DARK_BLUE, fillColor: SOLD_TO_BG },
              { text: "Color", bold: true, color: DARK_BLUE, fillColor: SOLD_TO_BG },
              { text: "Drawing No.", bold: true, color: DARK_BLUE, fillColor: "#FCCFB5" },
              { text: "Rev No.", bold: true, color: DARK_BLUE, fillColor: "#FCCFB5" },
            ],
            ...((data.components || []).length > 0 ? data.components : [{}]).map((comp, i) => [
              { text: comp.productGroup || "", fillColor: SOLD_TO_BG },
              { text: comp.pgComponent || "", fillColor: SOLD_TO_BG },
              { svg: toggleSvg((comp.apoStd || v("apoStandard")) === "Standard"), fit: [30, 14], fillColor: SOLD_TO_BG },
              { text: comp.color || "", fillColor: SOLD_TO_BG },
              { text: (data.drawings && data.drawings[i]) ? data.drawings[i].drawingNumber || "" : "", fillColor: "#FCCFB5" },
              { text: (data.drawings && data.drawings[i]) ? data.drawings[i].revisionNumber || "" : "", fillColor: "#FCCFB5" },
            ]),
          ],
        },
        layout: {
          hLineWidth: (i) => (i <= 1 ? 0.5 : 0),
          vLineWidth: (i, node) => {
            if (i === 4 || i === node.table.widths.length) return 1;
            if (i === 0) return 0.5;
            return 0;
          },
          hLineColor: () => DARK_BLUE,
          vLineColor: (i, node) => {
            if (i === 4 || i === node.table.widths.length) return "#C69C88";
            return DARK_BLUE;
          },
        },
        margin: [0, 0, 0, 10],
      },
      {
        table: {
          widths: ["33%", "34%", "33%"],
          body: [
            [
              { text: "Specify if entire scope is part of the supply", bold: true, fontSize: 7 },
              { text: "Specify additional scope to be considered", bold: true, fontSize: 7 },
              { text: "Explain what is part of the order and what is not", bold: true, fontSize: 7 },
            ],
            [v("scopeType"), v("scopeText"), v("partOrder")],
          ],
        },
        layout: "noBorders",
        margin: [0, 5, 0, 10],
      },

      // Section 3: COMMERCIAL DETAILS
      { text: "", pageBreak: "after" },
      sectionHeader("Section 3: COMMERCIAL DETAILS"),
      {
        table: {
          widths: ["14%", "14%", "15%", "17%", "13%", "14%", "13%"],
          headerRows: 1,
          body: [
            [
              { text: "PG", bold: true, color: DARK_BLUE, alignment: "center" },
              { text: "BOM Price", bold: true, color: DARK_BLUE, alignment: "center" },
              { text: "% Discount on BOM Price", bold: true, color: DARK_BLUE, alignment: "center" },
              { text: "Customer Order Basic Price", bold: true, color: DARK_BLUE, alignment: "center" },
              { text: "Dealer Margin", bold: true, color: DARK_BLUE, alignment: "center" },
              { text: "Dealer Order Basic Price", bold: true, color: DARK_BLUE, alignment: "center" },
              { text: "Final Basic Price", bold: true, color: DARK_BLUE, alignment: "center" },
            ],
            ...((data.pgDetails || []).length > 0 ? data.pgDetails : [{}]).map((pg) => [
              { text: pg.solutionOffering || "", alignment: "center" },
              { text: pg.bomPrice || "", alignment: "center" },
              { text: pg.discountOnBomPrice ? pg.discountOnBomPrice + "%" : "", alignment: "center" },
              { text: pg.cobp || "", alignment: "center" },
              { text: pg.dealerMargin ? pg.dealerMargin + "%" : "", alignment: "center" },
              { text: pg.dobp || "", alignment: "center" },
              { text: v("FinalBasicPrice"), alignment: "center" },
            ]),
          ],
        },
        layout: { hLineWidth: () => 0.5, vLineWidth: () => 0.5, hLineColor: () => DARK_BLUE, vLineColor: () => DARK_BLUE },
        margin: [0, 0, 0, 15],
      },
      {
        table: {
          widths: ["14%", "14%", "18%", "14%", "14%", "14%", "12%"],
          headerRows: 1,
          body: [
            [
              { text: "BOM Price", bold: true, italics: true, alignment: "center" },
              { text: "Discount on COBP %", bold: true, italics: true, alignment: "center" },
              { text: "Customer Order Basic Price", bold: true, italics: true, alignment: "center" },
              { text: "Dealer Margin %", bold: true, italics: true, alignment: "center" },
              { text: "Dealer Order Basic Price", bold: true, italics: true, alignment: "center" },
              { text: "Final Basic Price", bold: true, italics: true, alignment: "center" },
              { text: "Overall Outflow %", bold: true, italics: true, alignment: "center" },
            ],
            [{ text: v("FinalBasicPrice"), alignment: "center" }, { text: v("discountOnCOBP"), alignment: "center" }, { text: v("customerOrderBasicPrice"), alignment: "center" }, { text: v("dealerMarginPercent"), alignment: "center" }, { text: v("dealerOrderBasicPrice"), alignment: "center" }, { text: v("FinalBasicPrice"), alignment: "center" }, { text: v("Overall_Outflow"), alignment: "center" }],
          ],
        },
        layout: { hLineWidth: () => 0.5, vLineWidth: () => 0.5, hLineColor: () => DARK_BLUE, vLineColor: () => DARK_BLUE },
        margin: [0, 0, 0, 0],
      },
      {
        table: {
          widths: ["20%", "20%", "20%", "20%", "20%"],
          headerRows: 1,
          body: [
            [
              { text: "Supply Type", bold: true, italics: true, alignment: "center" },
              { text: "Supply Tax", bold: true, italics: true, alignment: "center" },
              { text: "Service Type", bold: true, italics: true, alignment: "center" },
              { text: "Service Tax", bold: true, italics: true, alignment: "center" },
              { text: "Price after Tax", bold: true, italics: true, alignment: "center" },
            ],
            [{ text: v("supplyType"), alignment: "center" }, { text: v("supplyTax"), alignment: "center" }, { text: v("serviceType"), alignment: "center" }, { text: v("serviceTax"), alignment: "center" }, { text: v("priceAfterTax"), alignment: "center" }],
          ],
        },
        layout: { hLineWidth: () => 0.5, vLineWidth: () => 0.5, hLineColor: () => DARK_BLUE, vLineColor: () => DARK_BLUE },
        margin: [0, 0, 0, 0],
      },

      // Payment Details
      {
        table: {
          widths: ["*"],
          body: [[{ text: "Payment Terms", bold: true, fontSize: 9, color: WHITE, fillColor: DARK_BLUE, alignment: "center", margin: [0, 2, 0, 2] }]],
        },
        layout: "noBorders",
        margin: [0, 0, 0, 0],
      },
      {
        table: {
          widths: ["16%", "7%", "12%", "35%", "30%"],
          body: [
            [
              { text: "Payment terms", bold: true, italics: true, color: DARK_BLUE, alignment: "center" },
              { text: "%", bold: true, italics: true, color: DARK_BLUE, alignment: "center" },
              { text: "Value in INR", bold: true, italics: true, color: DARK_BLUE, alignment: "center" },
              { text: "Dealer SAC", bold: true, italics: true, color: DARK_BLUE, alignment: "center" },
              { text: "LD Details", bold: true, italics: true, color: DARK_BLUE, alignment: "center" },
            ],
          ],
        },
        layout: { hLineWidth: () => 0.5, vLineWidth: () => 0.5, hLineColor: () => DARK_BLUE, vLineColor: () => DARK_BLUE },
        margin: [0, 0, 0, 0],
      },
      {
        table: {
          widths: ["16%", "7%", "12%", "35%", "30%"],
          body: [
            [
              { text: "Advance", bold: true, fillColor: "#FDDCB5" },
              { text: v("Advance"), fillColor: "#FDDCB5", alignment: "center" },
              { text: v("advanceValue"), fillColor: "#FDDCB5", alignment: "center" },
              {
                stack: [
                  { columns: [{ text: "SAC Applicable", bold: true, width: "25%" }, { text: v("DealerSAC_applicable"), width: "25%" }, { text: "Dealer SAC", bold: true, width: "25%" }, { text: v("Dealer_SAC"), width: "25%" }], margin: [0, 0, 0, 4] },
                  { columns: [{ text: "Dealer SAC Value", bold: true, width: "25%" }, { text: v("DealerSAC_value"), width: "25%" }, { text: "Dealer Code", bold: true, width: "25%" }, { text: v("DealerCode"), width: "25%" }], margin: [0, 0, 0, 4] },
                  { columns: [{ text: "Enq gen", bold: true, width: "22%" }, toggleWithLabel(v("enquiryGeneration") === "Yes"), { text: "Order Closing", bold: true, width: "22%" }, toggleWithLabel(v("orderClosing") === "Yes")], margin: [0, 0, 0, 4] },
                  { columns: [{ text: "Payment Collection", bold: true, width: "22%" }, toggleWithLabel(v("paymentCollection") === "Yes"), { text: "Installation", bold: true, width: "22%" }, toggleWithLabel(v("installation") === "Yes")], margin: [0, 0, 0, 4] },
                  { columns: [{ text: "Credit Sharing", bold: true, width: "22%" }, toggleWithLabel(v("creditSharing") === "Yes"), ...(v("creditSharing") === "Yes" ? [{ text: "Branch", bold: true, width: "22%" }, { text: v("creditSharingBranch") || "-", width: "*" }] : [{ text: "", width: "22%" }, { text: "", width: "*" }]) ] },
                  ...(v("creditSharing") === "Yes" ? [
                    { columns: [{ text: "Sharing Value", bold: true, width: "22%" }, { text: v("creditSharingValue") || "-", width: "25%" }, { text: "SM ID", bold: true, width: "22%" }, { text: v("creditSharingSMId") || "-", width: "*" }] },
                  ] : []),
                ], fillColor: "#A6D699", rowSpan: 6
              },
              {
                stack: [
                  { columns: [{ text: "LD applicable", bold: true, width: "50%" }, { text: v("LD_applicable"), width: "50%" }] },
                  ...(v("LD_applicable") === "Yes" ? [
                    { columns: [{ text: "Delivery Start", bold: true, width: "50%" }, { text: v("LD_Delivery_startdate") || "-", width: "50%" }], margin: [0, 3, 0, 0] },
                    { columns: [{ text: "Delivery End", bold: true, width: "50%" }, { text: v("LD_Delivery_enddate") || "-", width: "50%" }], margin: [0, 3, 0, 0] },
                    { columns: [{ text: "Delivery LD/week", bold: true, width: "50%" }, { text: v("LD_Delivery_LD_per_week") || "-", width: "50%" }], margin: [0, 3, 0, 0] },
                    { columns: [{ text: "Delivery Max LD", bold: true, width: "50%" }, { text: v("LD_Delivery_max_LD") || "-", width: "50%" }], margin: [0, 3, 0, 0] },
                    { columns: [{ text: "LD Min", bold: true, width: "50%" }, { text: v("LD_min") || "-", width: "50%" }], margin: [0, 3, 0, 0] },
                    { columns: [{ text: "LD Max", bold: true, width: "50%" }, { text: v("LD_max") || "-", width: "50%" }], margin: [0, 3, 0, 0] },
                    { columns: [{ text: "Install Start", bold: true, width: "50%" }, { text: v("LD_Instal_startdate") || "-", width: "50%" }], margin: [0, 3, 0, 0] },
                    { columns: [{ text: "Install End", bold: true, width: "50%" }, { text: v("LD_Instal_enddate") || "-", width: "50%" }], margin: [0, 3, 0, 0] },
                    { columns: [{ text: "Install LD/week", bold: true, width: "50%" }, { text: v("LD_Instal_LD_per_week") || "-", width: "50%" }], margin: [0, 3, 0, 0] },
                    { columns: [{ text: "Install Max LD", bold: true, width: "50%" }, { text: v("LD_Instal_max_LD") || "-", width: "50%" }], margin: [0, 3, 0, 0] },
                  ] : []),
                ], fillColor: "#B5D6FA", rowSpan: 6
              },
            ],
            [
              { text: "Against Delivery", bold: true, fillColor: "#FDDCB5" },
              { text: v("againstDeliveryPercent"), fillColor: "#FDDCB5", alignment: "center" },
              { text: v("againstDeliveryValue"), fillColor: "#FDDCB5", alignment: "center" },
              "", "",
            ],
            [
              { text: "Against Installation", bold: true, fillColor: "#FDDCB5" },
              { text: v("againstInstallationPercent"), fillColor: "#FDDCB5", alignment: "center" },
              { text: v("againstInstallationValue"), fillColor: "#FDDCB5", alignment: "center" },
              "", "",
            ],
            [
              { text: "Total", bold: true, fillColor: "#FDDCB5" },
              { text: v("totalPercent"), fillColor: "#FDDCB5", alignment: "center" },
              { text: v("totalValue"), fillColor: "#FDDCB5", alignment: "center" },
              "", "",
            ],
            [
              { text: "Installation charge", bold: true, fillColor: "#FDDCB5" },
              { text: "", alignment: "center", fillColor: "#FDDCB5" },
              { text: v("installationCharge"), alignment: "center", fillColor: "#FDDCB5" }, 
              "", "",
            ],
            [
              { text: "", fillColor: "#FDDCB5" },
              { text: "", fillColor: "#FDDCB5" },
              { text: "", fillColor: "#FDDCB5" },
              "", "",
            ],
          ],
        },
        layout: { hLineWidth: () => 0, vLineWidth: () => 0, paddingLeft: () => 4, paddingRight: () => 4, paddingTop: () => 3, paddingBottom: () => 3 },
        margin: [0, 0, 0, 5],
      },

      // Section 4: PROJECTS SUPPLY & INSTALLATION
      sectionHeader("Section 4: PROJECTS SUPPLY & INSTALLATION"),

      // Supply Chain
      subHeader("Supply Chain"),
      {
        table: {
          widths: ["12%", "13%", "12%", "13%", "12%", "18%", "10%", "10%"],
          body: [
            [
              { text: "Inspection Required", bold: true },
              v("inspectionReqd"),
              ...(v("inspectionReqd") === "Yes" ? [
                { text: "Inspection at", bold: true },
                v("inspectionAt"),
                { text: "Inspection Agency", bold: true },
                v("inspectionAgency"),
                { text: "Contact Name", bold: true },
                v("inspContactName"),
              ] : [
                { text: "", colSpan: 6 }, "", "", "", "", "",
              ]),
            ],
            [
              ...(v("inspectionReqd") === "Yes" ? [
                { text: "Contact Mobile", bold: true },
                v("inspContactMobile"),
                { text: "Contact Address", bold: true },
                v("inspContactAddress"),
                { text: "Supply Remarks", bold: true },
                { text: v("supplyRemarks"), colSpan: 3 }, "", "",
              ] : [
                { text: "Supply Remarks", bold: true },
                { text: v("supplyRemarks"), colSpan: 7 }, "", "", "", "", "", "",
              ]),
            ],
          ],
        },
        layout: "noBorders",
        margin: [0, 5, 0, 5],
      },

      // Logistics
      subHeader("Logistics"),
      {
        table: {
          widths: ["12%", "13%", "12%", "13%", "15%", "35%"],
          body: [
            [
              { text: "Site Contact Person", bold: true },
              v("siteContactPerson"),
              { text: "Site Contact Mobile", bold: true },
              v("siteContactMobile"),
              { text: "Logistics Remarks", bold: true },
              v("logisticsRemarks"),
            ],
          ],
        },
        layout: "noBorders",
        margin: [0, 5, 0, 5],
      },

      // Installation
      subHeader("Installation"),
      {
        table: {
          widths: ["13%", "12%", "13%", "12%", "13%", "12%", "13%", "12%"],
          body: [
            [
              { text: "QAP", bold: true },
              toggleWithLabel(v("miscQap") === "Yes"),
              { text: "Load test", bold: true },
              toggleWithLabel(v("miscLoadTest") === "Yes"),
              { text: "Process check", bold: true },
              { text: v("processCheckingVisitToFactory") },
              { text: "Site dimension", bold: true },
              toggleWithLabel(v("miscSiteDimension") === "Yes"),
            ],
            [
              { text: "Site readiness", bold: true },
              toggleWithLabel(v("miscSiteReadiness") === "Yes"),
              { text: "Visual inspection", bold: true },
              toggleWithLabel(v("miscVisualInspection") === "Yes"),
              { text: "Installation", bold: true },
              { text: v("miscInstallationBy") },
              { text: "Power Supply", bold: true },
              { text: v("scopeOfPowerSupply") },
            ],
            [
              { text: "Existing racks", bold: true },
              toggleWithLabel(v("miscExistingRacks") === "Yes"),
              { text: "Existing Racks Scope", bold: true },
              { text: v("scopeOfExistingRacksRemoval") },
              { text: "Working warehouse", bold: true },
              toggleWithLabel(v("miscWorkingWarehouse") === "Yes"),
              { text: "Unloading", bold: true },
              { text: v("scopeOfUnloading") },
            ],
            [
              { text: "Multiple floors", bold: true },
              toggleWithLabel(v("miscMultipleFloors") === "Yes"),
              { text: "Multiple Floors Details", bold: true },
              { text: v("multipleFloorDetails") },
              { text: "Covered space", bold: true },
              toggleWithLabel(v("miscCoveredSpace") === "Yes"),
              { text: "Installation Remarks", bold: true },
              { text: v("miscInstallationRemarks") },
            ],
          ],
        },
        layout: "noBorders",
        margin: [0, 5, 0, 5],
      },

      // Section 5: TIMELINES
      sectionHeader("Section 5: TIMELINES"),
      {
        table: {
          widths: ["18%", "11%", "11%", "11%", "11%", "11%", "11%", "16%"],
          headerRows: 2,
          body: [
            [
              { text: "", fillColor: "#D6DEE0" },
              { text: "DESIGN", bold: true, colSpan: 2, alignment: "center", fillColor: "#D6DEE0" }, "",
              { text: "SUPPLY", bold: true, colSpan: 2, alignment: "center", fillColor: "#D6DEE0" }, "",
              { text: "INSTALLATION", bold: true, colSpan: 2, alignment: "center", fillColor: "#D6DEE0" }, "",
              { text: "Remarks", bold: true, italics: true, alignment: "center", fillColor: "#D6DEE0" },
            ],
            [
              { text: "", fillColor: "#D6DEE0" },
              { text: "START", bold: true, alignment: "center", fillColor: "#D6DEE0" },
              { text: "FINISH", bold: true, alignment: "center", fillColor: "#D6DEE0" },
              { text: "START", bold: true, alignment: "center", fillColor: "#D6DEE0" },
              { text: "FINISH", bold: true, alignment: "center", fillColor: "#D6DEE0" },
              { text: "START", bold: true, alignment: "center", fillColor: "#D6DEE0" },
              { text: "FINISH", bold: true, alignment: "center", fillColor: "#D6DEE0" },
              { text: "Zero Date", bold: true, alignment: "center", fillColor: "#D6DEE0" },
            ],
            [
              { text: "PreOrder Timeline", bold: true, alignment: "center", fillColor: "#E8F5E9" },
              { text: v("preOrderDesignStart"), alignment: "center", fillColor: "#C8E6C9" },
              { text: v("preOrderDesignFinish"), alignment: "center", fillColor: "#C8E6C9" },
              { text: v("preOrderSupplyStart"), alignment: "center", fillColor: "#C8E6C9" },
              { text: v("preOrderSupplyFinish"), alignment: "center", fillColor: "#C8E6C9" },
              { text: v("preOrderInstallStart"), alignment: "center", fillColor: "#C8E6C9" },
              { text: v("preOrderInstallFinish"), alignment: "center", fillColor: "#C8E6C9" },
              { text: v("zeroDate"), alignment: "center", fillColor: "#C8E6C9" },
            ],
            // [
            //   { text: "Supply Installation", bold: true, alignment: "center" },
            //   { text: v("supplyDesignStart"), alignment: "center" },
            //   { text: v("supplyDesignFinish"), alignment: "center" },
            //   { text: v("supplySupplyStart"), alignment: "center" },
            //   { text: v("supplySupplyFinish"), alignment: "center" },
            //   { text: v("supplyInstallStart"), alignment: "center" },
            //   { text: v("supplyInstallFinish"), alignment: "center" },
            //   { text: v("timelineRemarks") },
            // ],
          ],
        },
        layout: { hLineWidth: () => 0.5, vLineWidth: () => 0.5, hLineColor: () => DARK_BLUE, vLineColor: () => DARK_BLUE },
        margin: [0, 0, 0, 10],
      },

      // Any other information
      {
        table: {
          widths: ["*"],
          body: [
            [{ text: "Any other information", bold: true, alignment: "center", fillColor: SOLD_TO_BG, margin: [0, 2, 0, 2] }],
            [{ text: v("OtherInformation"), fillColor: SOLD_TO_BG, margin: [5, 5, 5, 30] }],
          ],
        },
        layout: { hLineWidth: (i) => i === 1 ? 0.5 : 0, vLineWidth: () => 0, hLineColor: () => DARK_BLUE },
        margin: [0, 0, 0, 0],
      },
    ],
  };

  const fileName = `${v("enquiryNo") || "ISOB"}_ISOB.pdf`;
  pdfMake.createPdf(docDefinition).download(fileName);
};

export default generateIsobPdf;
